<div class="admin-content">
  <cei-admin-page-cabecalho
    titulo="Editar Usuário"
    rotaLista="/admin/pessoas"
    rotuloDetalhe="Detalhes do Usuário"
    [rotaVoltar]="['/admin/usuarios/detalhe', registroId]"
  />
  <form #adminForm="ngForm" class="admin-form" (ngSubmit)="onSubmit(adminForm)">
    <cei-panel class="admin-form-panel" [height]="'auto'">
      <cei-input-text
        label="Login:"
        inputId="login"
        name="login"
        required
        [(ngModel)]="form.login"
      />
      <cei-input-text
        label="Email:"
        inputId="email"
        name="email"
        type="email"
        email
        required
        [(ngModel)]="form.email"
      />
      <cei-input-text
        label="Senha:"
        inputId="password"
        name="password"
        type="password"
        [(ngModel)]="password"
      />
      <div class="checkbox-row">
        <cei-checkbox
          label="Ativo"
          inputId="is_active"
          name="is_active"
          [(ngModel)]="form.is_active"
        />
        <cei-checkbox
          label="Staff"
          inputId="is_staff"
          name="is_staff"
          [(ngModel)]="form.is_staff"
        />
      </div>

      <section class="admin-form-section">
        <h3 class="admin-form-section__title">Permissões do usuário</h3>
        <div class="admin-form-section__list" *ngIf="availablePermissions.length; else noPermissionsTemplate">
          <div class="admin-form-section__item" *ngFor="let permission of availablePermissions">
            <cei-checkbox
              variant="switch"
              [ngModel]="hasPermission(permission.id)"
              (ngModelChange)="togglePermission(permission, $event)"
              [label]="permission.name + ' (' + permission.codename + ')'"
              [inputId]="'permission-' + permission.id"
              [name]="'permission-' + permission.id"
            />
          </div>
        </div>
      </section>

      <section class="admin-form-section">
        <h3 class="admin-form-section__title">Grupos do usuário</h3>
        <div class="admin-form-section__list" *ngIf="availableGroups.length; else noGroupsTemplate">
          <div class="admin-form-section__item" *ngFor="let group of availableGroups">
            <cei-checkbox
              [ngModel]="hasGroup(group.id)"
              (ngModelChange)="toggleGroup(group, $event)"
              [label]="group.name"
              [inputId]="'group-' + group.id"
              [name]="'group-' + group.id"
            />
          </div>
        </div>
      </section>
    </cei-panel>
    <div class="admin-content__actions">
      <cei-button type="submit">Salvar</cei-button>
    </div>
  </form>
</div>

<ng-template #noPermissionsTemplate>
  <p>Nenhuma permissão disponível para seleção.</p>
</ng-template>

<ng-template #noGroupsTemplate>
  <p>Nenhum grupo disponível para seleção.</p>
</ng-template>
